import React from "react";
import { useTranslation } from "react-i18next";
import { GeolocateControl } from "react-map-gl";
import {
  MapTool,
  MapToolLabel,
  ZoomToLocationButton,
} from "./__styles__/FullPageMap";

export const GeolocationTool = ({
  geolocateClicked,
}: {
  geolocateClicked: () => Promise<void>;
}) => {
  const { t } = useTranslation();
  return (
    <MapTool>
      <MapToolLabel>{t("button-show-location")}</MapToolLabel>
      <ZoomToLocationButton onClick={geolocateClicked}>
        <GeolocateControl
          trackUserLocation={true}
          fitBoundsOptions={{ maxZoom: 18, minZoom: 18 }}
          style={{ position: "relative" }}
          aria-label={t("button-show-location")}
        />
      </ZoomToLocationButton>
    </MapTool>
  );
};
